module.exports = __webpack_public_path__ + "img/749DCBE9905D384B.67d005a4.png";